import moment from "moment";
import currentAccounts from "@/store/currentAccounts/currentAccounts.js";

class movements {
  constructor(
    movimId,
    concept,
    csCosto,
    dateLiq,
    dateMov,
    quantity,
    debe,
    haber,
    balance,
    typeMov,
    coment,
    excesoSup,
    excesoInf,
    conceptId,
    csCostoId
  ) {
    this.movimId = movimId;
    this.concept = concept;
    this.csCosto = csCosto;
    this.dateLiq = moment.utc(dateLiq).format("DD-MM-YYYY");
    this.dateMov = moment.utc(dateMov).format("DD-MM-YYYY");
    this.quantity =
      currentAccounts.state.edit.unit === "D"
        ? quantity
        : movements.convertToTime(quantity);
    this.debe =
      currentAccounts.state.edit.unit === "D"
        ? debe
        : movements.convertToTime(debe);
    this.haber =
      currentAccounts.state.edit.unit === "D"
        ? haber
        : movements.convertToTime(haber);
    this.balance =
      currentAccounts.state.edit.unit === "D"
        ? balance
        : movements.convertToTime(balance);
    this.typeMov = typeMov;
    this.coment = coment;
    this.excesoSup = excesoSup;
    this.excesoInf = excesoInf;
    this.conceptId = conceptId;
    this.csCostoId = csCostoId;
  }

  static fromJson({
    movimId,
    nomConcepto,
    nomCsCosto,
    fechaLiq,
    fechaMov,
    cantidad,
    debe,
    haber,
    saldo,
    tipoMov,
    comentario,
    excesoSup,
    excesoInf,
    conceptoId,
    csCostoId,
  }) {
    return new movements(
      movimId,
      nomConcepto,
      nomCsCosto,
      fechaLiq,
      fechaMov,
      cantidad,
      debe,
      haber,
      saldo,
      tipoMov,
      comentario,
      excesoSup,
      excesoInf,
      conceptoId,
      csCostoId
    );
  }

  static convertToTime(minutes) {
    const isNegative = minutes < 0;
    const absoluteMinutes = Math.abs(minutes);

    const hours = Math.floor(absoluteMinutes / 60)
      .toString()
      .padStart(2, "0");
    const mins = (absoluteMinutes % 60).toString().padStart(2, "0");

    return `${isNegative ? "-" : ""}${hours}:${mins}`;
  }
}

export default movements;
